/**
 * Misst die tatsächliche Höhe des Suchleisten-Subheaders im Banner und schreibt sie als --sb-subheader-h an #banner.
 * Das CSS rechnet damit in --banner-header-pb; der CSS-Wert (3rem) bleibt Fallback, falls JS nicht läuft oder kein Subheader existiert.
 * Nur Desktop (ab 1021px) – darunter steht die Suchleiste im Fluss und braucht den Wert nicht.
 */
export default function measureSubheader() {
    const banner = document.querySelector("#banner");
    const subheader = banner?.querySelector(".frame-type-host_searchbar > .subheader");
    if (!banner || !subheader) return;

    const desktop = window.matchMedia("(min-width: 1021px)");

    const update = () => {
        if (!desktop.matches) {
            banner.style.removeProperty("--sb-subheader-h");
            return;
        }
        const height = subheader.getBoundingClientRect().height;
        if (height > 0) {
            banner.style.setProperty("--sb-subheader-h", `${Math.ceil(height)}px`);
        }
    };

    update();

    /* Textumbruch durch Fensterbreite, Schriftart-Nachladen oder Inhaltsänderung */
    if ("ResizeObserver" in window) {
        new ResizeObserver(update).observe(subheader);
    } else {
        window.addEventListener("resize", update);
    }
    desktop.addEventListener?.("change", update);
    document.fonts?.ready.then(update);
}
